export const selectionTypes = {
  notSelected: 0,
  indeterminate: 1,
  selected: 2,
}
